/**
 * This file aims to provide tooling to validate geometry inputs (from a user for example).
 */

/**
 * given a number, this function will return whether this is a valid map longitude value.
 * @param  {number} lon
 * @returns boolean
 */
export const isLon = (lon: number): boolean => {
  return lon >= -180 && lon <= 180;
};

/**
 * given a number, this function will return whether this is a valid map latitude value.
 * @param  {number} lat
 * @returns boolean
 */
export const isLat = (lat: number): boolean => {
  return lat >= -90 && lat <= 90;
};

/**
 * Given a number this function will return whether this is a valid map zoom value.
 * @param  {number} zoom
 * @returns boolean
 */
export const isZoom = (zoom: number): boolean => {
  const minZoom = 0.0; // mapbox min zoom
  const maxZoom = 20.0; // mapbox max zoom
  return zoom >= minZoom && zoom <= maxZoom && isNaN(zoom) === false;
};
